import { z } from 'zod'
import { LearningSupportType } from '@/core/domain/resources/enums/LearningSupport'

const BaseLearningSupportSchema = z.object({
  id: z.number(),
  type: z.nativeEnum(LearningSupportType.Values),
  order: z.number(),
  estimatedTime: z.number()
})

// Schema pour le support de type GENIALLY
const GeniallyLearningSupportSchema = BaseLearningSupportSchema.extend({
  type: z.literal(LearningSupportType.Values.GENIALLY),
  url: z.string()
})

// Schema pour le support de type HTML (fichier hébergé sur le stockage objet)
const HtmlLearningSupportSchema = BaseLearningSupportSchema.extend({
  type: z.literal(LearningSupportType.Values.HTML),
  url: z.string(),
  storageKey: z.string(),
  originalFileName: z.string().nullable().optional(),
  fileSize: z.number().nullable().optional()
})

export const LearningSupportSchema = z.discriminatedUnion('type', [
  GeniallyLearningSupportSchema,
  HtmlLearningSupportSchema
])

// Liste de supports
export const LearningSupportListSchema = z.array(LearningSupportSchema)

// Types dérivés des schemas
export type LearningSupportEntity = z.infer<typeof LearningSupportSchema>
export type LearningSupportListEntity = z.infer<typeof LearningSupportListSchema>

export type GeniallyLearningSupportEntity = z.infer<typeof GeniallyLearningSupportSchema>
export type HtmlLearningSupportEntity = z.infer<typeof HtmlLearningSupportSchema>

// Type guards pour les différents types de supports
export const isGeniallySupport = (
  support: LearningSupportEntity
): support is GeniallyLearningSupportEntity => {
  return support.type === LearningSupportType.Values.GENIALLY
}

export const isHtmlSupport = (
  support: LearningSupportEntity
): support is HtmlLearningSupportEntity => {
  return support.type === LearningSupportType.Values.HTML
}
